export default "__VITE_ASSET__cJZj4RMZ__"